import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-soc-pillar-system",
  "use": "icon-soc-pillar-system-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" fill=\"none\" id=\"icon-soc-pillar-system\">\r\n  <!-- ① 系统设置：简洁齿轮（线框） -->\r\n  <g fill=\"none\" stroke=\"currentColor\" stroke-width=\"64\" stroke-linecap=\"round\" stroke-linejoin=\"round\">\r\n    <circle cx=\"512\" cy=\"512\" r=\"160\" />\r\n    <path d=\"M512 192v96M512 736v96M192 512h96M736 512h96M286 286l68 68M670 670l68 68M738 286l-68 68M354 670l-68 68\" />\r\n  </g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/soc-pillar-system.svg
// module id = 4cIj
// module chunks = 491